<app-header-container>
  <div header-content [style.background-color]="'white'" *ngIf="!isLoading; else loading">
    <div class="d-flex flex-column gap-3">
      <app-breadcrumbs *ngIf="!isMobile" [breadcrumbs]="breadcrumbs" />
      <div class="d-flex justify-content-between">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</app-header-container>

<ng-template #loading>
  <div class="d-flex flex-column gap-3">
    <lib-loading-shimmer [height]="'1rem'" />
    <lib-loading-shimmer [height]="'2rem'" />
  </div>
</ng-template>
